import { useQuery } from "@tanstack/react-query"
import { useDispatch as useOriginalDispatch } from "react-redux"
import appsyncApi from "src/services/appsyncApi"
import { Dispatch } from "./types"

export const useDispatch = () => useOriginalDispatch<Dispatch>()

export const useMyOrganization = () => useQuery(["getMyOrganization"], () => appsyncApi.getMyOrganization())
